import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Loader from '../common/Loader';
import { withTranslation, WithTranslation } from "react-i18next";
import { useActions } from '../../hooks/useActions';
import { useAppSelector } from '../../store/hooks';
import { EntityId } from '../../types/models';

interface DashboardUsersOwnProps {
  customerId?: EntityId;
  className?: string;
  isLoading?: boolean;
}

const DashboardUsers = (props: DashboardUsersOwnProps & WithTranslation) => {
  const { t } = props; // [t, i18n]
  const actions = useActions();
  const { dashboardId } = useParams();
  const users = useAppSelector((store) => store.users.users);
  const [showDisabledUsers, setShowDisabledUsers] = useState(false);

  // Was a side-effect in the constructor.
  useEffect(() => {
    actions.fetchUsers(props.customerId);
  }, [actions, props.customerId]);

  // Render all users with access to the dashboard, not disabled at first render.
  // - ticking 'Show disabled users' rendered all.
  const renderUsers = (dashId: string | undefined) => [...users] // copy: .sort() mutates in place (redux state)
    .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
    .map((user, i) => {
      let show = false;
      let isDashboardUser = false;
      return (
        <div key={i} style={{display: 'flex'}}>
          {show = (!user.disabled || showDisabledUsers)}
          {isDashboardUser = (!!dashId && !!user.dashboards?.includes(dashId))}
          <div style={{display: (show && isDashboardUser) ? props.className : 'none'}}>
            <Link
              style={{float: 'left', color: user.disabled ? 'grey' : 'green'}}
              to={`/user/${user.uid}`}
              >{user.name}
            </Link>
          </div>
        </div>
      );
    });

  // Boolean toggle tickbox handler
  const handleShowDisabledCheckBox = (_event: React.ChangeEvent<HTMLInputElement>) => {
    setShowDisabledUsers((prev) => !prev);
  };

  return (
    <div>
      <label>
        <input
          type="checkbox"
          onChange={handleShowDisabledCheckBox}
        />
        {t('user.showDisabled')}
      </label>
      {props.isLoading && <Loader />}
      <div style={{height:"0.4em"}}></div>
      {renderUsers(dashboardId)}
    </div>
  );
};

// This component had CSSModules(DashboardUsers) with NO styles map — which throws
// at runtime the moment a styleName renders ("… CSS module is undefined"). All its
// styling is inline style={}, so the styleName + CSSModules wrapper were dropped.
export default withTranslation('common')(DashboardUsers);
